<input #cameraInput class="display-none" type="file" capture="camera" accept="image/*" (change)="selectedFiles.emit($event.target.files)">
<input #fileInput class="display-none" type="file" [multiple]="multiple" accept="image/*" (change)="selectedFiles.emit($event.target.files)">
<button *ngIf="showCamera$ | async" mat-icon-button class="high-emphasis" (click)="cameraInput.click()">
  <mat-icon>photo_camera</mat-icon>
</button>
<button *ngIf="showGallery$ | async"  mat-icon-button class="high-emphasis" (click)="fileInput.click()">
  <mat-icon>insert_photo</mat-icon>
</button>